var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.008,
    height: 27.008,
    viewBox: "0 0 27.008 27.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_Left",
    transform: "translate(-35.992 -191.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4288",
    "data-name": "Path 4288",
    d: "M15,1.5a13.507,13.507,0,0,1,5.257,25.946A13.507,13.507,0,0,1,9.747,2.562,13.42,13.42,0,0,1,15,1.5Zm0,24.553A11.049,11.049,0,1,0,3.955,15,11.061,11.061,0,0,0,15,26.053Z",
    transform: "translate(34.492 190.246)",
    fill: "#4286f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4289",
    "data-name": "Path 4289",
    d: "M16.638,22.776a1.224,1.224,0,0,1-.868-.36L10.86,17.506a1.228,1.228,0,0,1,0-1.736L15.77,10.86A1.228,1.228,0,0,1,17.506,12.6l-4.042,4.042,4.042,4.042a1.228,1.228,0,0,1-.868,2.1Z",
    transform: "translate(32.857 188.611)",
    fill: "#4286f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4290",
    "data-name": "Path 4290",
    d: "M21.549,18.955H11.728a1.228,1.228,0,1,1,0-2.455h9.821a1.228,1.228,0,1,1,0,2.455Z",
    transform: "translate(32.857 187.521)",
    fill: "#4286f5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.9b026dec5fd897c4a6fffd85452704c3.svg";
export { ForwardRef as ReactComponent };